import { strapiClient } from "@shared/api";
import rebuild from "@shared/api/rebuild";
import { NotFoundError } from "@shared/utils/not-found-error";
import { getSeoConfig } from "@shared/utils/seo/seo-helper";

import { type DocumentPageType, mapDtoToDocumentPage } from "../model";

type DocumentPageResponse = {
  document: DocumentPageType;
};

export const getDocumentPage = async (
  slug: string,
): Promise<DocumentPageResponse> => {
  const pageSearchParams = {
    filters: {
      slug: {
        $eq: slug,
      },
    },
    populate: {
      content: {
        on: {
          "article.section-name": {
            populate: "*",
          },
          "article.text-block": {
            populate: "*",
          },
          "article.table": {
            populate: {
              tabletRows: {
                populate: "*",
              },
              columnTitle: {
                populate: "*",
              },
              columnSubtitle: {
                populate: "*",
              },
            },
          },
          "article.gallery": {
            populate: "*",
          },
          "article.video": {
            populate: "*",
          },
          "article.quote-with-author": {
            populate: "*",
          },
        },
      },
      otherDocuments: {
        populate: {
          documents: {
            populate: {
              documentPage: {
                populate: "*",
              },
              documentFile: {
                populate: "*",
              },
            },
          },
        },
      },
      seo: {
        populate: {
          ogImage: {
            populate: "*",
          },
        },
      },
    },
  };

  const documentPages = strapiClient.collection("document-pages");

  const page = await documentPages.find({ ...pageSearchParams });

  const documentPage = mapDtoToDocumentPage(page);
  const currentDocument = documentPage[0];

  if (!currentDocument) {
    throw new NotFoundError(`Document with slug "${slug}" not found`);
  }

  return rebuild({
    document: {
      ...currentDocument,
      seo: getSeoConfig.document(currentDocument),
    },
  }) as DocumentPageResponse;
};
